import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './DashLayout.css';
import logoImg from '../../asserts/l.png';

const DashLayout = (props) => {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <div className="dash-root">

            <div className={`dash-overlay ${menuOpen ? 'dash-overlay--open' : ''}`} onClick={() => setMenuOpen(false)} />

            <aside className={`dash-sidebar ${menuOpen ? 'dash-sidebar--open' : ''}`}>
                <div className="dash-sidebar-logo">
                    <img src={logoImg} alt="logo" className="dash-logo-img" />
                    <div className="dash-logo-text">
                        <span className="dash-logo-name">FoxEvents</span>
                        <span className="dash-logo-sub">SM Services</span>
                    </div>
                </div>

                <div className="dash-nav">

                    <Link to="/home" className="no-underline-link">
                        <div className={`dash-nav-item ${props.active === 'dashboard' ? 'dash-nav-item--active' : ''}`}>
                            <svg className="dash-nav-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="2" y="2" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
                                <rect x="11" y="2" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
                                <rect x="2" y="11" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
                                <rect x="11" y="11" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
                            </svg>
                            <p className="dash-nav-label">Dashboard</p>
                        </div>
                    </Link>

                    <Link to="/events" className="no-underline-link">
                        <div className={`dash-nav-item ${props.active === 'events' ? 'dash-nav-item--active' : ''}`}>
                            <svg className="dash-nav-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="3" y="4" width="14" height="13" rx="2" stroke="currentColor" strokeWidth="1.5"/>
                                <path d="M3 8h14" stroke="currentColor" strokeWidth="1.5"/>
                                <path d="M7 2v3M13 2v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                            </svg>
                            <p className="dash-nav-label">Events</p>
                        </div>
                    </Link>

                    <Link to="/bookings" className="no-underline-link">
                        <div className={`dash-nav-item ${props.active === 'bookings' ? 'dash-nav-item--active' : ''}`}>
                           <svg
  className="dash-nav-icon"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M4 6a1 1 0 011-1h10a1 1 0 011 1v2a1.5 1.5 0 000 4v2a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a1.5 1.5 0 000-4V6z"
    stroke="currentColor"
    strokeWidth="1.5"
  />

  <path
    d="M7 9h6M7 12h4"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
  />
</svg>
                            <p className="dash-nav-label">Bookings</p>
                        </div>
                    </Link>

                    <Link to="/users" className="no-underline-link">
                        <div className={`dash-nav-item ${props.active === 'users' ? 'dash-nav-item--active' : ''}`}>
                            <svg className="dash-nav-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="10" cy="7" r="3" stroke="currentColor" strokeWidth="1.5"/>
                                <path d="M4 17c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                            </svg>
                            <p className="dash-nav-label">Users</p>
                        </div>
                    </Link>

                    <Link to="/categories" className="no-underline-link">
                        <div className={`dash-nav-item ${props.active === 'categories' ? 'dash-nav-item--active' : ''}`}>
                            <svg className="dash-nav-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 5h14M3 10h10M3 15h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                            </svg>
                            <p className="dash-nav-label">Categories</p>
                        </div>
                    </Link>

                    <Link to="/support" className="no-underline-link">
                        <div className={`dash-nav-item ${props.active === 'support' ? 'dash-nav-item--active' : ''}`}>
                            <svg className="dash-nav-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 4h12a1 1 0 011 1v8a1 1 0 01-1 1H6l-3 3V5a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                            </svg>
                            <p className="dash-nav-label">Support Messages</p>
                        </div>
                    </Link>

                    <Link to="/reviews" className="no-underline-link">
                        <div className={`dash-nav-item ${props.active === 'reviews' ? 'dash-nav-item--active' : ''}`}>
                            <svg className="dash-nav-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 2l2.09 4.26L17 7.27l-3.5 3.41.83 4.82L10 13.27l-4.33 2.23.83-4.82L3 7.27l4.91-.71L10 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                            </svg>
                            <p className="dash-nav-label">Feedbacks & Reviews</p>
                        </div>
                    </Link>

                    <Link to="/sections" className="no-underline-link">
                        <div className={`dash-nav-item ${props.active === 'sections' ? 'dash-nav-item--active' : ''}`}>
                            <svg className="dash-nav-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2 5a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2V5z" stroke="currentColor" strokeWidth="1.5"/>
                                <path d="M2 13a2 2 0 012-2h5a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2z" stroke="currentColor" strokeWidth="1.5"/>
                                <path d="M13 13a2 2 0 012-2h1a2 2 0 012 2v2a2 2 0 01-2 2h-1a2 2 0 01-2-2v-2z" stroke="currentColor" strokeWidth="1.5"/>
                            </svg>
                            <p className="dash-nav-label">Sections</p>
                        </div>
                    </Link>

                    <Link to="/settings" className="no-underline-link">
                        <div className={`dash-nav-item ${props.active === 'settings' ? 'dash-nav-item--active' : ''}`}>
                            <svg className="dash-nav-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="10" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.5"/>
                                <path d="M10 2v1.5M10 16.5V18M2 10h1.5M16.5 10H18M4.22 4.22l1.06 1.06M14.72 14.72l1.06 1.06M4.22 15.78l1.06-1.06M14.72 5.28l1.06-1.06" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                            </svg>
                            <p className="dash-nav-label">Settings</p>
                        </div>
                    </Link>

                </div>

                <div className="dash-sidebar-bottom">
                    <Link to="/logout" className="no-underline-link">
                        <div className="dash-nav-item dash-logout">
                            <svg className="dash-nav-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7 3H4a1 1 0 00-1 1v12a1 1 0 001 1h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                <path d="M13 14l3-4-3-4M16 10H8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            <p className="dash-nav-label">Logout</p>
                        </div>
                    </Link>
                </div>
            </aside>

            <div className="dash-main">

                <header className="dash-header">
                    <div className="dash-header-left">
                        <p className="dash-page-title">{props.title}</p>
                    </div>

                    <div className="dash-header-right">

                       

                        <div className="dash-lang-div">
                            <span className="dash-lang-btn dash-lang-btn--active">EN</span>
                            <span className="dash-lang-btn">AR</span>
                        </div>

                        <button className="dash-notif-btn">
                            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 2a6 6 0 00-6 6v3l-1.5 2.5h15L16 11V8a6 6 0 00-6-6z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                                <path d="M8 15.5a2 2 0 004 0" stroke="currentColor" strokeWidth="1.5"/>
                            </svg>
                            <span className="dash-notif-dot"></span>
                        </button>

                        <div className="dash-admin">
                            <div className="dash-admin-avatar">
                                <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="10" cy="7" r="3" stroke="currentColor" strokeWidth="1.5"/>
                                    <path d="M4 17c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                </svg>
                            </div>
                            <p className="dash-admin-name">Admin</p>
                        </div>

                        <button className="dash-burger" onClick={() => setMenuOpen(!menuOpen)}>
                            <span className={`dash-burger-line ${menuOpen ? 'dash-burger-line--1-open' : ''}`}></span>
                            <span className={`dash-burger-line ${menuOpen ? 'dash-burger-line--2-open' : ''}`}></span>
                            <span className={`dash-burger-line ${menuOpen ? 'dash-burger-line--3-open' : ''}`}></span>
                        </button>
                    </div>
                </header>

                <main className="dash-content">
                    {props.children}
                </main>

            </div>

        </div>
    );
};

export default DashLayout;